'use client'

import Image from 'next/image'
import { Autoplay, EffectCreative } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'

import { cn } from '@/_lib/utils'

interface AHomeHeroCarouselCardItem {
	text: string
	bgClass: string
	image: {
		src: string
		alt: string
		height: number
		width: number
	}
}

/**
 * AHomeHeroCarouselCard
 * @param items - The items to display in the carousel
 * @returns A React component that displays a carousel of items
 */
const AHomeHeroCarouselCard = ({ items }: { items: AHomeHeroCarouselCardItem[] }) => {
	// Only enable loop if there are enough items (at least 2 for slidesPerView: 'auto')
	const enableLoop = items.length >= 2

	return (
		<Swiper
			modules={[Autoplay, EffectCreative]}
			effect='creative'
			className='overflow-hidden'
			creativeEffect={{
				prev: {
					translate: ['-100%', 0, -1],
					opacity: 0
				},
				next: {
					translate: ['100%', 0, 0]
				}
			}}
			slidesPerView='auto'
			loop={enableLoop}
			autoplay={{
				delay: 2000,
				disableOnInteraction: false
			}}
		>
			{items.map((item, index) => (
				<SwiperSlide key={index} className='h-full'>
					<div
						className={cn(
							'px-5 py-6 rounded-2xl flex lg:flex-col justify-between items-start lg:items-center gap-4 h-full lg:min-h-[260px]',
							item.bgClass
						)}
					>
						<p className='text-white text-xl font-light'>{item.text}</p>

						<Image
							unoptimized={true}
							src={item.image.src}
							alt={item.image.alt}
							width={item.image.height}
							height={item.image.width}
							className='my-auto mx-0 h-16 w-16 lg:h-full lg:max-h-32 lg:w-full lg:max-w-32 relative lg:-mb-3'
						/>
					</div>
				</SwiperSlide>
			))}
		</Swiper>
	)
}

export default AHomeHeroCarouselCard
